import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';

import DropdownMenu from './DropdownMenu';
import DropdownMenuItem from './DropdownMenuItem';

import { DENTAL } from '../../assets/Domains';

import IconPlans from './img/plans.svg';

export default function ProfileDropdown(props) {
  const logoutLabel = (
    <div className="dropdown-item dropdown-item--logout">
      <div className="dropdown-item__icon" />
      <div className="dropdown-item__label">
        <span className="dropdown-item__label--secondary">Logout</span>
      </div>
    </div>
  );
  const accountsettings = (
    <div className="dropdown-item dropdown-item--logout">
      <div className="dropdown-item__icon" />
      <div className="dropdown-item__label">
        <span className="dropdown-item__label--secondary">Account Settings</span>
      </div>
    </div>
  );
  const managestaff = (
    <div className="dropdown-item dropdown-item--logout">
      <div className="dropdown-item__icon" />
      <div className="dropdown-item__label">
        <span className="dropdown-item__label--secondary">Manage Staff Accounts</span>
      </div>
    </div>
  );
  const name = [
    props.profileInfo.FIRST_NAME || '',
    props.profileInfo.LAST_NAME || '',
  ].join(' ');

  const profileLabel = (
    <div className="dropdown-item">
      <div className="dropdown-item__icon dropdown-item__icon--profile-icon">
        <i className="material-icons">person</i>
      </div>
      <div className="dropdown-item__label">
        <span className="dropdown-item__label--primary">{name}</span>
        <span className="dropdown-item__label--secondary">
          {props.profileInfo.EMAIL}
        </span>
      </div>
    </div>
  );

  let planName;
  if (
    props.billingInfo &&
    props.billingInfo.plan &&
    props.billingInfo.plan.value
  ) {
    planName = props.billingInfo.plan.value.name;
  }

  let planLabel;

  if (planName) {
    planLabel = (
      <div className="dropdown-item">
        <div className="dropdown-item__icon">
          <img src={IconPlans} alt="My Plan" />
        </div>
        <div className="dropdown-item__label">
          <span
            className="dropdown-item__label--primary"
            style={{ display: 'flex', alignItems: 'center', whiteSpace: 'pre-line' }}
          >
            {planName}
            <NavLink
              to="/app/billing"
              className={classnames(
                'dropdown-item__label__cta',
                'btn',
                'btn--link',
                'btn--sm',
                {
                  hide: true,
                },
              )}
            >
              Update Plan
            </NavLink>
          </span>
        </div>
      </div>
    );
  }
  const adminroles = ['ADMIN', 'CS_ADMIN', 'CS_SETUP', 'CS_SALES'];
  return (
    <DropdownMenu {...props}>
      <DropdownMenuItem label={profileLabel} type="BUTTON" />
      {window.innerWidth > 768 &&
      <DropdownMenuItem label={planLabel} type="BUTTON" />
      }
      {window.innerWidth > 768 &&
      <DropdownMenuItem label={accountsettings} path="/app/accountsettings" />
      }
      {(props.userRole && adminroles.includes(props.userRole.role) && window.innerWidth > 768) &&
      <DropdownMenuItem label={managestaff} path="/app/managestaff" />
      }
      <DropdownMenuItem label={logoutLabel} path="/logout" />
    </DropdownMenu>
  );
}

ProfileDropdown.defaultProps = {
  profileInfo: {
    FIRST_NAME: '',
    LAST_NAME: '',
    EMAIL: '',
  },
  billingInfo: {
    plan: {
      value: {
        name: '',
      },
    },
  },
};

ProfileDropdown.propTypes = {
  profileInfo: PropTypes.shape({
    FIRST_NAME: PropTypes.string,
    LAST_NAME: PropTypes.string,
    EMAIL: PropTypes.string,
  }),
  billingInfo: PropTypes.shape({
    plan: PropTypes.shape({
      value: PropTypes.shape({
        name: PropTypes.string,
      }),
    }),
  }),
  currentDomain: PropTypes.string.isRequired,
};
